// extracted by mini-css-extract-plugin
export var pillWrapper = "_l5-0";
export var showOverflow = "_l5-1";